import { type ReactNode } from 'react';

import { EditorAnalyticsContext, type EditorAnalytics } from './editor-analytics-context';

export function EditorAnalyticsProvider({
  editorType,
  children,
}: EditorAnalytics & { children: ReactNode }) {
  return (
    <EditorAnalyticsContext.Provider value={{ editorType }}>
      {children}
    </EditorAnalyticsContext.Provider>
  );
}
